import React from "react";

import InfoTooltip from "@components/tooltip/info-tooltip";

export type Field = {
  title: string;
  tooltip?: string;
  render: () => React.ReactNode;
};

const FormFields = ({
  fields,
  width = 200,
}: {
  fields: Field[];
  width?: number;
}) => {
  return (
    <div className="flex flex-col gap-4">
      {fields.map((field) => (
        <div key={field.title} className="flex items-baseline">
          <div
            className="text-gray-600 text-sm shrink-0 flex items-center justify-between mr-4"
            style={{ width: `${width}px` }}
          >
            <div>{field.title}</div>
            {field.tooltip && <InfoTooltip text={field.tooltip} />}
          </div>
          <div className="flex-1">{field.render()}</div>
        </div>
      ))}
    </div>
  );
};

export default FormFields;
